import { render, staticRenderFns } from "./NewLeaveRequest.vue?vue&type=template&id=2d657dbe&scoped=true&"
import script from "./NewLeaveRequest.vue?vue&type=script&lang=js&"
export * from "./NewLeaveRequest.vue?vue&type=script&lang=js&"
import style0 from "./NewLeaveRequest.vue?vue&type=style&index=0&id=2d657dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d657dbe",
  null
  
)

export default component.exports